import { SkeletonText as SkeletonTextComponent } from '@billy/design-system'
import styled from '@emotion/styled'

export const SkeletonText = styled(SkeletonTextComponent)`
  margin-left: auto;
`
